module.exports = __webpack_public_path__ + "img/ic_search_inactive.f76e768f.svg";